import React, { useMemo } from 'react';
import ReactWebChat, { createDirectLine, createBrowserWebSpeechPonyfillFactory } from 'botframework-webchat';
import { Button } from '@material-ui/core';

export default function ChatBotChannel() {
    // const fetchCredentials = async () => {
    //     const res = await fetch('https://webchat-mockbot-streaming.azurewebsites.net/speechservices/token', {
    //       method: 'POST'
    //     });

    //     if (!res.ok) {
    //       throw new Error('Failed to fetch authorization token and region.');
    //     }

    //     const { region, token: authorizationToken } = await res.json();

    //     return { authorizationToken, region };
    //   };

  const directLine = useMemo(() => createDirectLine({ token: 'xUerrqiyDLw.Xcgg8_fldIe5_rkRmI2cc2zS9VAXxjsL2LrImA8Tejw' }),[]);
  const webSpeech = createBrowserWebSpeechPonyfillFactory()
  return <ReactWebChat 
  directLine={directLine} userID="YOUR_USER_ID"
  webSpeechPonyfillFactory={webSpeech} 
  locale='pt-PT'
  />;
};
